  <div class="add-prescription-item-container">
  <app-expansion-panel [title]="'Add Medicine Details:'" [expanded]="true">
  <div>
    <app-form-row-split>
      <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Medicine Name'">
        </app-label>
        <app-auto-complete [control]="prescriptionNameItm" 
                           [template]="template"
                           [items]="medicineList"
                           (onEnter)="OnOptionSelected($event)"></app-auto-complete>
      </app-form-row>
      <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Unit(s)'">
        </app-label>
        <app-number-control
            [placeholder]="'Number of medicines'"
            [hintText]="'Number of Tablets. Example- 2 Tablets'"
            [required] = "true"
            [control]="prescriptionNoMedicineItm"
            [minLength]="1"
            [maxLength]="320">
        </app-number-control>
      </app-form-row>
    </app-form-row-split>
    <app-form-row-split>
      <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Routine'">
        </app-label>
        <ng-container *ngFor="let routine of routineList()">
          <app-checkbox
                      [item]="routine"
                      (onChange)="onRoutineSelected(routine)">
          </app-checkbox>
        </ng-container>
      </app-form-row>
      <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Frequency'">
        </app-label>
        <app-number-control
            [placeholder]="'2 Days'"
            [hintText]="'Number of days'"
            [required] = "true"
            [control]="prescriptionItm"
            [minLength]="1"
            [maxLength]="320">
        </app-number-control>
      </app-form-row>
    </app-form-row-split>
    
    <app-form-row-split>
      <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Intake'">
        </app-label>
          <app-radio-button
                      [items]="intakeList()"
                      (onChange)="onIntakeSelected($event)">
          </app-radio-button>
      </app-form-row>
      <app-form-row>
        <app-button [button]="addMedicineButton">
        </app-button>
      </app-form-row>
    </app-form-row-split>
  </div>
  </app-expansion-panel>
  <app-expansion-panel [title]="'Add More Details:'" [expanded]="true">
  <div>
    <app-form-row-split>
      <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Add Medical History'">
        </app-label>
        <app-textbox
            [control]="medicalHistoryItm"
            [minLength]="10"
            [maxLength]="320"
            [multiLine]="true">
        </app-textbox>
      </app-form-row>
    </app-form-row-split>
    <app-form-row-split>
      <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Add Diagnosis'">
        </app-label>
        <app-textbox
            [control]="diagnosisItm"
            [minLength]="10"
            [maxLength]="320"
            [multiLine]="true">
        </app-textbox>
      </app-form-row>
    </app-form-row-split>
    <app-form-row-split>
      <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Follow up date'">
        </app-label>
        <app-basic-calender [calender]="calender"
                            [control]="dateControl"
                            (selected)="onDateChanege($event)">
        </app-basic-calender>
      </app-form-row>
    </app-form-row-split>
  </div>
  <div>
    <app-form-row-split>
      <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Add Note'">
        </app-label>
        <app-textbox
            [control]="prescriptionNoteItm"
            [minLength]="10"
            [maxLength]="320"
            [multiLine]="true">
        </app-textbox>
      </app-form-row>
      <app-form-row>
        <app-button [button]="addNoteButton">
        </app-button>
      </app-form-row>
    </app-form-row-split>
  </div>
  </app-expansion-panel>
</div>
  <div class="prescription-container" *ngIf="prescriptionItem !== null">
    <div class="prescription-header">
      <div class="logo-container">
        <div class="prescription-logo"><img src="assets/images/arogyamm.png" alt="" srcset=""></div>
        <div class="doctor-name">
            Dr. {{prescriptionItem!.doctorName}}
            <div>{{prescriptionItem!.degree}}</div>
        </div>
      </div>
      <div class="doctor-container">
        <br>
        <div>{{prescriptionItem!.clinicName}}</div>
        <div>{{prescriptionItem!.address}}</div>
        <div *ngIf="prescriptionItem!.registration" class="registration-number">Medical Registration Number: {{prescriptionItem!.registration}}</div>
      </div>
    </div>
    <div class="patient-container">
      <div>{{prescriptionItem!.patientName}}</div>
      <div>{{prescriptionItem!.date | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="medicine-container">
      <ng-container *ngIf="prescriptionItem.medicalHistory">
        <div class="medicine-header">MEDICAL HISTORY</div>
        <p class="header-details">{{prescriptionItem.medicalHistory}}</p>
      </ng-container>
      <ng-container *ngIf="prescriptionItem.diagnosis">
        <div class="medicine-header">PROVISIONAL DIAGNOSIS</div>
        <p class="header-details">{{prescriptionItem.diagnosis}}</p>
      </ng-container>
      <ng-container *ngIf="prescriptionItem.followUpDate">
        <div class="followup-container" (click)="removeFollowUp()" *ngIf="prescriptionItem!.followUpDate">
          <div class="medicine-header">FOLLOW UP DATE - {{prescriptionItem.followUpDate | date:'dd MMM yyyy'}}</div>
          <div class="remove-btn">Remove Follow Up<app-icon [item]="closeIcon"></app-icon></div>
        </div>
      </ng-container>
    </div>
    <div class="medicine-container">
      <div class="medicine-header">MEDICINES</div>
      <app-table *ngIf="prescriptionData"
                [dataSource]="dataSource"
                [columnDefinition]="displayedColumns"
                [showFilter]="false"
                [pageSize]="200">
      </app-table>
    </div>
    <div class="notes-container">
      <div>Note: {{prescriptionItem!.notes}}</div>
      <div class="remove-note-btn" (click)="removeNote()" *ngIf="prescriptionItem!.notes">
        <div>Remove Note</div><app-icon [item]="closeIcon"></app-icon>
      </div>
    </div>
    <div class="sign-container">
      <div>Dr. {{prescriptionItem!.doctorName}}</div>
      <div>{{prescriptionItem!.degree}}</div>
    </div>
  <div class="disclaimer-container">
    Disclaimer: This prescription is based on the information provided by you. Visit doctor in case of emergency. This prescription is valid in India only.
  </div>
  </div>

<ng-template #statusColumn
            let-item="item"
            let-value="value">
            <div class="remove-btn" (click)="removeMedicaions(value)">
              <div>Remove Item</div><app-icon [item]="closeIcon"></app-icon>
            </div>
</ng-template>

<ng-template #errorMsg>
  <app-label
    [text]="'Error while saving the details'">
  </app-label>
</ng-template>

<ng-template #successMsgTitle>
  <app-label
    [text]="'Success'">
  </app-label>
</ng-template>
<ng-template #successMsg>
  <div class="msg-container">
    <app-label
      [text]="'Details saved successfully'">
    </app-label>
  </div>
</ng-template>

<ng-template #template
            let-item="item">
            <ng-container *ngIf="item">
                <span>{{item.value.name}}</span>
            </ng-container>
</ng-template>